import { store } from '@src/state/store';
import { tournamentUpdated } from '@src/state/slices/slice_tournament';

import { Tournament } from '@src/lib/types';

export default () => (data: Tournament[]) => {
  data.map((tournament: Tournament) =>
    store.dispatch(tournamentUpdated(tournament)),
  );
};
